<div class="modal-container">
  <div class="modal-header no-print">
    <h2 mat-dialog-title>
      <mat-icon>print</mat-icon>
      <span>Imprimir Lista de Produtos</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- CONTENT BODY -->
  <div class="content-body modal-print-container">
    <!-- LOADING STATE -->
    @if (isLoading) {
    <div class="loading-container no-print">
      <app-loading-box width="100%" height="300px"></app-loading-box>
    </div>
    }

    <!-- TABLE CONTENT -->
    @if (relatorioProdutos.length > 0) {
    <div [hidden]="isLoading">
      <div class="table-responsive">
        <table mat-table [dataSource]="relatorioProdutos">
          <!-- Código SKU Column -->
          <ng-container matColumnDef="codigoSku">
            <th mat-header-cell *matHeaderCellDef style="width: 15%">Código SKU</th>
            <td mat-cell *matCellDef="let element">{{ element.codigoSku }}</td>
          </ng-container>
          <!-- Descrição Column -->
          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef style="width: 35%">Descrição</th>
            <td mat-cell *matCellDef="let element">{{ element.descricao }}</td>
          </ng-container>
          <!-- Unidade Column -->
          <ng-container matColumnDef="unidade">
            <th mat-header-cell *matHeaderCellDef style="width: 10%">Unidade</th>
            <td mat-cell *matCellDef="let element">{{ element.unidade }}</td>
          </ng-container>
          <!-- Preço de Venda Column -->
          <ng-container matColumnDef="precoVenda">
            <th mat-header-cell *matHeaderCellDef style="width: 20%" class="text-end">Preço de Venda</th>
            <td mat-cell *matCellDef="let element" class="text-end">{{ element.precoVenda | currency: 'BRL' }}</td>
          </ng-container>
          <!-- Preço de Custo Column -->
          <ng-container matColumnDef="precoCusto">
            <th mat-header-cell *matHeaderCellDef style="width: 20%" class="text-end">Preço de Custo</th>
            <td mat-cell *matCellDef="let element" class="text-end">{{ element.precoCusto | currency: 'BRL' }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
    }

    <!-- EMPTY STATE -->
    @if (!isLoading && relatorioProdutos.length === 0) {
    <div class="text-center p-4">
      <p>Nenhum registro encontrado para os filtros selecionados.</p>
    </div>
    }
  </div>

  <!-- FOOTER ACTIONS -->
  <div class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
    @if (!isLoading && relatorioProdutos.length > 0) {
    <button mat-flat-button class="btn-primary" (click)="imprimir()">
      <mat-icon>print</mat-icon> Imprimir
    </button>
    }
  </div>
</div>